import { render } from "./OrderFormLadingBill.vue?vue&type=template&id=6d1ed951&scoped=true&ts=true"
import script from "./OrderFormLadingBill.vue?vue&type=script&lang=ts"
export * from "./OrderFormLadingBill.vue?vue&type=script&lang=ts"

import "./OrderFormLadingBill.vue?vue&type=style&index=0&id=6d1ed951&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1ed951"]])

export default __exports__